// extracted by mini-css-extract-plugin
export var arrows = "_4a-5";
export var decrementer = "_4a-9";
export var disabled = "_4a-3";
export var error = "_4a-1";
export var hiddenText = "_4a-a";
export var incrementer = "_4a-8";
export var input = "_4a-7";
export var inputWrapper = "_4a-0";
export var readonly = "_4a-2";
export var regular = "_4a-6";
export var small = "_4a-4";